var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#e89033",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 459 c0 -12 34 -58 82 -110 l82 -89 56 0 56 0 82 89 c124 135 128 131 -138 131 -216 0 -220 0 -220 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 161 l0 -80 54 -30 c29 -17 56 -31 60 -31 3 0 6 50 6 110 l0 110 -60 0 -60 0 0 -79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b848ba93760c532a4648a0dfb5bb6122.svg";
export { ForwardRef as ReactComponent };